export default [
  {
    path: '/projects/:projectId(\\d+)/people/teams/:pathMatch(.*)',
    component: () => import('./RouteProjectsPeopleTeams.vue'),
  },
];
